<script setup>
import Datatable from '@/components/Shared/Table/Datatable.vue';
import { inject, ref } from 'vue';
import moment from 'moment';

const trans = inject('trans');

const props = defineProps({
  pagination: {
    type: Object,
    default: null,
  },
  tickets: {
    type: Array,
    required: true,
  },
  filters: {
    type: Object,
    default: () => ({}),
  },
});
const headers = [
  { text: '#', value: 'id', align: 'center' },
  { text: trans('__JSON__.Date created'), value: 'dateCreated', align: 'start' },
  { text: trans('__JSON__.Expert'), value: 'sendTo.partner.companyName', align: 'start' },
  { text: trans('__JSON__.Subject'), value: 'subject', align: 'start' },
  { text: trans('__JSON__.Status'), value: 'status', align: 'start' },
  { text: trans('common.application') + ' 1', value: 'application1.name', align: 'start' },
  { text: trans('common.application') + ' 2', value: 'application2.name', align: 'start' },
  { text: '', value: 'action', align: 'start' },
];

const filters = ref(props.filters);
</script>

<template>
  <datatable
    :headers="headers"
    :items="tickets"
    :loading="false"
    :pagination="pagination"
    :filters="filters"
    :search-placeholder="trans('__JSON__.Search in tickets')"
    searchable
  >
    <template #item-date-created="{ item }">
      {{ moment(item.dateCreated).format('DD/MM/YYYY') }}
    </template>
    <template #item-action="{ item }">
      <inertia-link class="tile-button" :href="route('dashboard.support.show', item.id)">
        <svg class="icon">
          <use xlink:href="#eye-icon"></use>
        </svg>
      </inertia-link>
    </template>
  </datatable>
</template>
